import { Routes } from '@common/constants';
import { BookableList, BookableListItemType } from '@features/List';
import { toNightlyPrice } from '@features/rooms/helpers/toNightlyPrice.helper';
import { useTranslations } from '@lang';
import { parseDateToString } from '@utils/helpers';
import moment from 'moment';
import { FC } from 'react';
import { RatesListingProps } from './RatesListing.types';

export const RatesListing: FC<RatesListingProps> = ({
  roomId,
  datePartyData,
  rates,
  roomIdsInBasket,
}) => {
  const { t } = useTranslations();
  const linkCTA = t('room.bookRoom');
  const numberOfNights = moment(datePartyData.toDate).diff(moment(datePartyData.fromDate), 'days');
  const numRoomsInBasket = (upgradeRoomId) =>
    (roomIdsInBasket ?? []).filter((id) => id === upgradeRoomId).length;
  const { rooms: _, ...datePartyDataNoRooms } = datePartyData;

  const items: BookableListItemType[] = rates.map(
    ({
      rateId: id,
      rateImageThumbnail: imageThumbnail,
      rateTitle: title,
      rateDescription: description,
      pricePerStay,
      rateTerms: terms,
      rateImageUrl: imageUrl,
      roomUpgrade,
      paymentTerms,
      discount,
    }) => {
      const linkParamIds = { id, room: roomId };
      return {
        id,
        imageUrl: imageThumbnail || imageUrl,
        title,
        description,
        pricePerStay,
        pricePerNight: toNightlyPrice(pricePerStay, discount, numberOfNights),
        terms,
        numberOfNights,
        linkRoute: Routes.RATE_BOOKING,
        linkParams: {
          ...linkParamIds,
          ...datePartyDataNoRooms,
          fromDate: parseDateToString(datePartyData.fromDate),
          toDate: parseDateToString(datePartyData.toDate),
          spaDate: parseDateToString(datePartyData.fromDate),
          bookingStep:
            roomUpgrade && numRoomsInBasket(roomUpgrade.id) < (roomUpgrade?.quantity || Infinity)
              ? 'upgrade'
              : 'guestDetailsStep',
        },
        linkCTA,
        upgrade: roomUpgrade,
        paymentTerms,
        discount,
      };
    }
  );

  return <BookableList items={items} numberOfRooms={datePartyData?.rooms?.length || 1} />;
};
